import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, go } from './util';

/**
 * /projects/join/{token}: the link in a project invitation email. Signed in, the member joins the project
 * straight away; signed out, they sign up (or log in) first. Logging in reloads this page, which then joins.
 */
export default class ProjectJoin extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.token = String(m.route.param('token') || '');
    this.error = null;
    this.joining = false;
    if (app.session.user) this.join();
  }
  join() {
    this.joining = true;
    app.request({
      method: 'POST',
      url: api('/projects-join'),
      body: {
        token: this.token
      },
      errorHandler: () => {}
    }).then(r => {
      app.alerts.show({
        type: 'success'
      }, 'You’ve joined ' + r.project.name + '.');
      m.route.set('/projects/' + r.project.slug);
    }).catch(e => {
      this.joining = false;
      this.error = e && e.response && e.response.message || 'This invitation couldn’t be accepted.';
      m.redraw();
    });
  }
  open(which) {
    const b = document.querySelector('.item-' + which + ' .Button, .item-' + which + ' button');
    if (b) b.click();
  }
  view() {
    if (this.error) {
      return m("div", {
        className: "VEvt VEvt-empty"
      }, m("i", {
        className: "fas fa-people-carry-box",
        "aria-hidden": "true"
      }), m("h3", null, this.error), m("p", null, "Ask the person who invited you to send a new invitation."), m(Button, {
        className: "Button",
        onclick: go('/projects')
      }, "Projects"));
    }
    if (app.session.user) return m(LoadingIndicator, null);
    return m("div", {
      className: "VEvt VEvt-empty"
    }, m("i", {
      className: "fas fa-people-carry-box",
      "aria-hidden": "true"
    }), m("h3", null, "You\u2019ve been invited to a community project on Voucha"), m("p", null, "Join Voucha (it\u2019s free) with the email the invitation was sent to, or log in, and you\u2019ll be added to the project."), m("span", {
      className: "VEvt-actions VBiz-joinButtons"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.open('signUp')
    }, "Sign up"), m(Button, {
      className: "Button",
      onclick: () => this.open('logIn')
    }, "Log in")));
  }
}
flarum.reg.add('voucha-community', 'forum/projects/ProjectJoin', ProjectJoin);